// Environment configuration
const config = {
  development: {
    API_URL: 'http://127.0.0.1:5000',
    AGENT_URL: 'http://127.0.0.1:8001',
  },
  production: {
    API_URL: '',  // Empty because frontend code already includes /api prefix
    AGENT_URL: '',
  }
};

// Determine which environment we're in
// If accessing via port 8080, use production config (nginx proxy)
// Otherwise, if localhost:3000, use development config (direct backend)
const isDockerEnv = window.location.port === '8080';
const isDevelopment = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') && !isDockerEnv;
const currentEnv = isDevelopment ? 'development' : 'production';

// Export the current environment's configuration
export const API_URL = config[currentEnv].API_URL;
export const AGENT_URL = config[currentEnv].AGENT_URL;   